import { ILayer, LayerCategory, LayerType } from '../../modules/layers/model';
import { ELSAOutput } from '../../modules/analysis/model';
import { PreviewLayer, splitPath } from '../../utils/preview';
import layers from 'components/layers';

const ELSA_CATEGORICAL_LEGEND = {
  type: 'basic',
  items: [
    {
      value: 0,
      name: '',
    },
    {
      value: 1,
      name: 'Protect',
      color: '#3D528B',
    },
    {
      value: 2,
      name: 'Manage',
      color: '#22908D',
    },
    {
      value: 3,
      name: 'Restore',
      color: '#5CC863',
    },
    {
      value: 4,
      name: 'Urban Greening',
      color: '#FDE726',
    },
  ],
};

const ELSA_CONTINUOUS_LEGEND = {
  type: 'gradient',
  items: [
    {
      value: 0,
      name: 'Min',
      color: '#3F0952',
    },
    {
      value: 0.25,
      name: 'Low',
      color: '#3D528B',
    },
    {
      value: 0.5,
      name: 'Medium',
      color: '#22908D',
    },
    {
      value: 0.75,
      name: 'High',
      color: '#5CC863',
    },
    {
      value: 1,
      name: 'Max',
      color: '#FDE726',
    },
  ],
};

const ELSA_TILER_URL = 'https://titiler.impactobservatory.com';
const IO_STORAGE_URL = 'https://impactobservatory.blob.core.windows.net';
const ELSA_CONTAINER = 'io-elsa';
const ELSA_READ_SAS =
  'sv=2020-10-02&st=2022-07-18T20%3A38%3A56Z&se=2023-07-17T20%3A38%3A00Z&sr=c&sp=rl&sig=%2BdKoyAfMVWhnXLw%2F4nStoZxvxQtbciw4zxEBog1KYdg%3D';

export const PreviewELSALayer = (path: string, name: string = '', slug: string = ''): ILayer => {
  // creates a temporary layer object from a tif in blob storage
  const layer = PreviewLayer(path);

  // update with default ELSA config
  const { filename, directory } = splitPath(path);
  if (!slug) {
    slug = filename.replaceAll('_', '-');
  }
  let legend = {};
  let rescale = '';
  const colormap = 'viridis';
  if (name) {
    layer.name = name;
  } else {
    layer.name = filename.replaceAll('_', ' ');
  }

  if (directory === 'elsa_inputs' || filename.indexOf('_HM') > 0) {
    // all inputs are continuous
    legend = ELSA_CONTINUOUS_LEGEND;
    rescale = '0,1';
  } else {
    // adopted and generated maps are categorical
    legend = ELSA_CATEGORICAL_LEGEND;
    rescale = '0,4';
  }

  layer.category = [LayerCategory.ELSA];
  layer.legendConfig = legend;
  layer.licenseRestriction = false;
  layer.source.tiles[0] += `&rescale=${rescale}&colormap_name=${colormap}`;

  return layer;
};

export const PreviewELSAGroup = (
  path: string,
  name: string = '',
  slug: string = '',
  layerList: ELSAOutput[]
): ILayer => {
  // creates a temporary layer group with internal references to the layerList
  const GROUP_LEGEND = { legendType: 'yearpicker' };
  // use yearpicker to get dropdown of referenced layers

  const group = {
    id: path,
    slug,
    name,
    legendConfig: GROUP_LEGEND,
    source: {
      format: 'image/png',
      type: LayerType.raster,
    },
    type: LayerType.group,
    references: layerList.map((l) => PreviewELSALayer(`${path}/${l.file_path}`, l.name)),
  };

  return group;
};

export const getExternalURL = (filename: string, directory: string) =>
  `${IO_STORAGE_URL}/${ELSA_CONTAINER}/${directory}/${filename}?${ELSA_READ_SAS}`;
